"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _QueryTaskPlaylistConstants = require("crm_data/queues/QueryTaskPlaylistConstants");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _generalStore = _interopRequireDefault(require("general-store"));

var ElasticSearchAPI = _interopRequireWildcard(require("crm_data/elasticSearch/api/ElasticSearchAPI"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var initialState = (0, _immutable.fromJS)({
  currentTaskId: null,
  error: false,
  hasMore: false,
  isFetching: false,
  offset: null,
  searchQuery: null,
  taskIds: (0, _immutable.OrderedSet)(),
  total: null
});

function getStoredQuery() {
  var storedQuery = localStorage.getItem(_QueryTaskPlaylistConstants.PLAYLIST_QUERY_LOCAL_STORAGE_KEY);

  if (storedQuery) {
    return (0, _immutable.fromJS)(JSON.parse(storedQuery));
  }

  return null;
}

var _default = _generalStore.default.defineFactory().defineName('QueryTaskPlaylistStore').defineGetInitialState(function () {
  return initialState;
}).defineGet(function (state, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  switch (key) {
    case 'searchQuery':
      {
        (0, _Dispatch.dispatchQueue)(_ActionTypes.TASK_PLAYLIST_GET_STORED_QUERY);
        return getStoredQuery();
      }

    case 'taskIds':
    case 'total':
      {
        var _options$offset = options.offset,
            offset = _options$offset === void 0 ? 0 : _options$offset,
            taskId = options.taskId;
        var currentTaskId = parseInt(taskId, 10);
        var needsToFetch = currentTaskId !== state.get('currentTaskId');

        if (needsToFetch && !state.get('isFetching')) {
          (0, _Dispatch.dispatchQueue)(_ActionTypes.TASK_PLAYLIST_GET_TASKS, {
            offset: offset,
            currentTaskId: currentTaskId
          });
        }

        return state.get(key);
      }

    default:
      if (key) {
        return state.get(key);
      }

      return state;
  }
}).defineResponseTo(_ActionTypes.TASK_PLAYLIST_GET_STORED_QUERY, function (state) {
  var searchQuery = getStoredQuery();
  return state.merge({
    searchQuery: searchQuery
  });
}).defineResponseTo(_ActionTypes.TASK_PLAYLIST_GET_MORE_TASKS, function (state) {
  var _state$toObject = state.toObject(),
      offset = _state$toObject.offset,
      currentTaskId = _state$toObject.currentTaskId,
      hasMore = _state$toObject.hasMore;

  if (hasMore) {
    (0, _Dispatch.dispatchQueue)(_ActionTypes.TASK_PLAYLIST_GET_TASKS, {
      offset: offset,
      currentTaskId: currentTaskId,
      concatResults: true
    });
  }

  return state;
}).defineResponseTo(_ActionTypes.TASK_PLAYLIST_GET_TASKS, function (state, _ref) {
  var offset = _ref.offset,
      currentTaskId = _ref.currentTaskId,
      _ref$concatResults = _ref.concatResults,
      concatResults = _ref$concatResults === void 0 ? false : _ref$concatResults;
  // always fetch the most up-to-date query from local storage
  var searchQuery = getStoredQuery();

  if (!searchQuery || state.get('isFetching')) {
    return state;
  }

  var queryForNextTask = searchQuery.set('offset', offset);
  ElasticSearchAPI.search(_ObjectTypes.TASK, queryForNextTask).then(function (response) {
    var taskIds = response.get('engagements').toList();
    var total = response.get('total');
    var newOffset = response.get('offset');
    var hasMore = response.get('has-more', false);
    (0, _Dispatch.dispatchQueue)(_ActionTypes.TASK_PLAYLIST_SET_SEARCH_RESULTS, {
      currentTaskId: currentTaskId,
      taskIds: taskIds,
      total: total,
      offset: newOffset,
      hasMore: hasMore,
      concatResults: concatResults
    });
  }, function () {
    return (0, _Dispatch.dispatchQueue)(_ActionTypes.TASK_PLAYLIST_ERROR);
  });
  return state.set('isFetching', true);
}).defineResponseTo(_ActionTypes.TASK_PLAYLIST_SET_SEARCH_RESULTS, function (state, _ref2) {
  var currentTaskId = _ref2.currentTaskId,
      taskIds = _ref2.taskIds,
      total = _ref2.total,
      offset = _ref2.offset,
      hasMore = _ref2.hasMore,
      concatResults = _ref2.concatResults;
  return state.merge({
    currentTaskId: currentTaskId,
    isFetching: false,
    error: false,
    total: total,
    offset: offset,
    hasMore: hasMore
  }).update('taskIds', function (taskIdSet) {
    if (concatResults) {
      return taskIdSet.union(taskIds);
    }

    return (0, _immutable.OrderedSet)(taskIds);
  });
}).defineResponseTo(_ActionTypes.TASK_PLAYLIST_ERROR, function (state) {
  return state.merge({
    isFetching: false,
    error: true
  });
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;